import React from "react";

import StartTrialBtn from "./StartTrialBtn";
import phoneOffer from "../../assets/images/mains/heroPhoneOffer.webp";
import heroImgGraph0 from "../../assets/images/mains/orangevivus.svg";
import heroImgGraph2 from "../../assets/images/mains/31percentvivus.svg";
import heroImgGraph1 from "../../assets/images/mains/22percentvivus.svg";
import GDPR from "../../assets/images/mains/GDPR.svg";
import CCPA from "../../assets/images/mains/CCPA_animated.svg";
import PlayStoryVideo from "./PlayStoryVideo";

const LandingPage = () => {
  return (
    <div className="website-landingSection hero-container reduce-topspace container-md">
      <div className="hero-row row m-0 w-100 h-100 website-heroRow">
        <div className="col-12 col-lg-5 heroText-container cutomize-heroText-container flex-col">
          <div className="heroTheme flex-col">
            <div className="heroTitle mt-5" x-intersect="$el.classList.add('fadeInUp-parallax')">
              <h2>Predicting Buying Intent using Cookie-agnostic AI</h2>
            </div>
            <div className="heroDesc my-4" x-intersect="$el.classList.add('fadeInUp-parallax')">
              <p>
              Uncover the hidden value of your anonymous visitors with our disruptive Cookie-agnostic AI.
              </p>
            </div>
            <div className="my-2 my-lg-5 hero-btn-group" x-intersect="$el.classList.add('fadeInUp-parallax')">
              <StartTrialBtn title="Start Free Trial" href="/free-trial" />
              {/* <PlayStoryVideo videoUrl="https://dashboard.causalfunnel.com/assets/causalfunnel_explainer.mp4"/> */}
            </div>
            {/* <div className="hero-icon-container mt-3 mt-lg-0" x-intersect="$el.classList.add('fadeInUp-parallax')">
              <img className="img-fluid m-1" src={GDPR } alt="GDPR"/>
              <img className="img-fluid m-1" src={ CCPA} alt="CCPA"/>
            </div> */}
          </div>
        </div>
        <div className="col-12 col-lg-7 heroPhoto-container">
          <div className="hero-img-container phoneOffer">
            <div className="hero-img-phone">
              <div className="heroImg-graph-container">
                <div className="store-icon-container ">
                  <svg
                    _ngcontent-gtk-c31=""
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                  >
                    <path
                      _ngcontent-gtk-c31=""
                      fill="#0F3267"
                      d="M10 0a10 10 0 1 1 0 20 10 10 0 0 1 0-20zm3.3 6.11H4.34a.41.41 0 0 0 0 .83h8.94a2.89 2.89 0 0 1 0 5.77H7.65a.41.41 0 0 0 0 .83h5.64a3.71 3.71 0 0 0 0-7.43zm0 1.65a2.06 2.06 0 1 0 2.05 2.06c0-1.13-.92-2.06-2.06-2.06zm-2.83 3.3h-4.7a.41.41 0 0 0 0 .83h4.7a.41.41 0 0 0 0-.83zM13.3 8.6a1.24 1.24 0 1 1 0 2.47 1.24 1.24 0 0 1 0-2.47zm-3.3.8H3.41a.41.41 0 1 0 0 .83h6.6c.22 0 .4-.19.4-.42a.41.41 0 0 0-.41-.4zm.47-1.65H6.24a.41.41 0 1 0 0 .83h4.23a.41.41 0 1 0 0-.83z"
                    ></path>
                  </svg>{" "}
                  My Store{" "}
                  <svg
                    _ngcontent-gtk-c31=""
                    width="10"
                    height="4"
                    viewBox="0 0 10 4"
                  >
                    <polyline
                      _ngcontent-gtk-c31=""
                      fill="none"
                      stroke="#0F3267"
                      points="1 0 5 4 9 0"
                    ></polyline>
                  </svg>
                </div>

                <div className="heroGraphs">
                  <div className="heroImg-horzgraph mt-4">
                    <img
                      
                      className="img-fluid"
                      src={heroImgGraph0}
                      alt="CausalFunnel Website LandingPage Hero Image"
                      x-intersect="$el.classList.add('scale-parallax')"
                    />
                  </div>
                  <div className="flex herominigraph-container mb-4">
                    <div className="heroImg-graph-item ">
                      <img
                        className="img-fluid"
                        src={heroImgGraph1}
                        alt="CausalFunnel Website LandingPage Hero Image"
                        x-intersect="$el.classList.add('scale-parallax')"
                      />
                    </div>
                    <div className="heroImg-graph-item middle-horzSpacing">
                      <img
                        className="img-fluid"
                        src={heroImgGraph2}
                        alt="CausalFunnel Website LandingPage Hero Image"
                        x-intersect="$el.classList.add('scale-parallax')"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="hero-mobile-img">
                <img
                  loading="lazy"
                  className="img-fluid"
                  src={phoneOffer}
                  alt="CausalFunnel Website LandingPage Hero Image"
                  x-intersect="$el.classList.add('scale-parallax')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
